import { Textfield } from '@src/shared/fields/text-field';
import { AnnouncementSectionTitle } from './announcement-section-title';

export function AnnouncementInfoSection() {
  return (
    <section className='flex w-full flex-col gap-4 rounded-xl border border-primary-100 bg-white p-6'>
      <AnnouncementSectionTitle title='1. Announcement Info' />
      <Textfield
        name='name'
        label='Announcement Name'
        placeholder='Enter announcement name'
        helperText="This won't appear to the students"
      />
    </section>
  );
}
